
export default {
  name: 'ProductPhysicalCtaButton',
  props: {
    isPending: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      quantity: 1,
    }
  },

  watch: {
    quantity (quantity) {
      this.$emit('quantity', quantity)
    },
  },
}
